export const recommendation = {
  intervention: {
    cost: {
      label: "Cost",
    },
    dueDate: {
      label: "Due date",
    },
    interventionType: {
      label: "Intervention type",
    },
    startDate: {
      label: "Start date",
    },
  },
  add: {
    label: "New recommendation",
    title: "Create a new recommendation",
  },
  select: {
    placeholder: "Select an existing recommendation",
    emptyPlaceholder: "No existing recommendations",
  },
  delete: {
    label: "Delete recommendation",
  },
  disassociate: {
    label: "Disassociate recommendation",
  },
  recommendedBy: {
    label: "Recommended by ",
  },
  noRecommendations: {
    active: "No recommendations",
    enable: {
      label: "No recommendations",
      title: 'Add "no recommendation" status',
    },
    disable: {
      label: "No recommendations",
      title: 'Remove "no recommendation" status',
    },
  },
  staticState: {
    missing: "Missing recommendations",
    not_required: "No recommendations",
    in_progress: "Uncompleted recommendations",
    completed: "Completed recommendations",
  },
};
